module.exports = __webpack_public_path__ + "static/partner9-7fde1d5787ae7d50192d7dc90cb497ad.png";